export function getApiBaseUrl() {
  return (process.env.REACT_APP_API_URL || 'http://localhost:3000/api').replace(/\/$/, '');
}

/** Concatène une route API (`/elearning/...` ou legacy `/api/elearning/...`) avec la base API. */
export function joinApiUrl(path: string, query?: URLSearchParams) {
  const base = getApiBaseUrl();
  let normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (base.endsWith('/api') && normalizedPath.startsWith('/api/')) {
    normalizedPath = normalizedPath.slice(4);
  }
  const qs = query?.toString();
  return qs ? `${base}${normalizedPath}?${qs}` : `${base}${normalizedPath}`;
}
